const CONTRACT_FREQUENCY = [
  { key: 'DAY', value: 'DAY', label: 'Day(s)' },
  { key: 'WEEK', value: 'WEEK', label: 'Week(s)' },
  { key: 'MONTH', value: 'MONTH', label: 'Month(s)' },
];

const getContractFrequency = (t) => [
  { key: 'DAY', value: 'DAY', label: t('common:optionList.CONTRACT_FREQUENCY.DAY') },
  { key: 'WEEK', value: 'WEEK', label: t('common:optionList.CONTRACT_FREQUENCY.WEEK') },
  { key: 'MONTH', value: 'MONTH', label: t('common:optionList.CONTRACT_FREQUENCY.MONTH') },
];

const SUSPENSION_REASON = [
  {
    key: 'VACATION',
    value: 'VACATION',
    label: 'Vacation',
  },
  {
    key: 'HOSPITALISATION',
    value: 'HOSPITALISATION',
    label: 'Hospitalisation',
  },
  {
    key: 'FAULTY_DEVICE',
    value: 'FAULTY_DEVICE',
    label: 'Faulty Device(s)',
  },
  {
    key: 'PENDING_OTHER_INSTRUCTIONS',
    value: 'PENDING_OTHER_INSTRUCTIONS',
    label: 'Pending Other Instructions',
  },
  {
    key: 'TREATMENT_ADJUSTMENT',
    value: 'TREATMENT_ADJUSTMENT',
    label: 'Treatment Adjustment',
  },
  {
    key: 'OTHERS',
    value: 'OTHERS',
    label: 'Others',
  }
];

const getSuspensionReason = (t) => [
  {
    key: 'VACATION',
    value: 'VACATION',
    label: t('common:optionList.SUSPENSION_REASON.VACATION'),
  },
  {
    key: 'HOSPITALISATION',
    value: 'HOSPITALISATION',
    label: t('common:optionList.SUSPENSION_REASON.HOSPITALISATION'),
  },
  {
    key: 'FAULTY_DEVICE',
    value: 'FAULTY_DEVICE',
    label: t('common:optionList.SUSPENSION_REASON.FAULTY_DEVICE'),
  },
  {
    key: 'PENDING_OTHER_INSTRUCTIONS',
    value: 'PENDING_OTHER_INSTRUCTIONS',
    label: t('common:optionList.SUSPENSION_REASON.PENDING_OTHER_INSTRUCTIONS'),
  },
  {
    key: 'TREATMENT_ADJUSTMENT',
    value: 'TREATMENT_ADJUSTMENT',
    label: t('common:optionList.SUSPENSION_REASON.TREATMENT_ADJUSTMENT'),
  },
  {
    key: 'OTHERS',
    value: 'OTHERS',
    label: t('common:optionList.SUSPENSION_REASON.OTHERS'),
  }
];

const EXTENSION_REASON = [
  {
    key: 'EXTENSION_OF_TREATMENT',
    value: 'EXTENSION_OF_TREATMENT',
    label: 'Extension of Treatment',
  },
  {
    key: 'PENDING_DOCTORS_REVIEW',
    value: 'PENDING_DOCTORS_REVIEW',
    label: 'Pending Doctor\'s Review',
  },
  {
    key: 'DOCTORS_RECOMENDATION',
    value: 'DOCTORS_RECOMENDATION',
    label: 'Doctor\'s Recommendation',
  },
  {
    key: 'SUPPORT_RECOVERY',
    value: 'SUPPORT_RECOVERY',
    label: 'Support Recovery',
  },
  {
    key: 'OTHERS',
    value: 'OTHERS',
    label: 'Others',
  }
];

const getExtensionReason = (t) => [
  {
    key: 'EXTENSION_OF_TREATMENT',
    value: 'EXTENSION_OF_TREATMENT',
    label: t('common:optionList.EXTENSION_REASON.EXTENSION_OF_TREATMENT'),
  },
  {
    key: 'PENDING_DOCTORS_REVIEW',
    value: 'PENDING_DOCTORS_REVIEW',
    label: t('common:optionList.EXTENSION_REASON.PENDING_DOCTORS_REVIEW'),
  },
  {
    key: 'DOCTORS_RECOMENDATION',
    value: 'DOCTORS_RECOMENDATION',
    label: t('common:optionList.EXTENSION_REASON.DOCTORS_RECOMENDATION'),
  },
  {
    key: 'SUPPORT_RECOVERY',
    value: 'SUPPORT_RECOVERY',
    label: t('common:optionList.EXTENSION_REASON.SUPPORT_RECOVERY'),
  },
  {
    key: 'OTHERS',
    value: 'OTHERS',
    label: t('common:optionList.EXTENSION_REASON.OTHERS'),
  }
];

const CRUD_SEND_TO_PARTICIPANT_VIA = [
  { key: 'EMAIL', value: 'EMAIL', label: 'Email' },
  { key: 'SMS', value: 'SMS', label: 'SMS' },
];

const getCrudSendToParticipantVia = (t) => [
  { key: 'EMAIL', value: 'EMAIL', label: t('common:currentProfile.notificationsTab.email') },
  { key: 'SMS', value: 'SMS', label: t('common:currentProfile.notificationsTab.sms') },
];

/**
 * Get error messages with translations
 * @param {Function} t - Translation function from i18n
 * @returns {Array} Array of error message objects with translated strings
 */
const getErrorMessages = (t) => [
  {
    key: 'NO_SELECTED_DEVICES',
    title: t('programs.adminProgramme.errorMessages.noSelectedDevices.title'),
    description: t('programs.adminProgramme.errorMessages.noSelectedDevices.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.noSelectedDevices.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.noSelectedDevices.cancelLabel')
  },
  {
    key: 'DEVICE_TYPE_ERROR_ADMIN_PROGRAM',
    title: t('programs.adminProgramme.errorMessages.deviceTypeErrorAdminProgram.title'),
    description: t('programs.adminProgramme.errorMessages.deviceTypeErrorAdminProgram.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.deviceTypeErrorAdminProgram.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.deviceTypeErrorAdminProgram.cancelLabel')
  },
  {
    key: 'DEVICE_TYPE_ERROR_ENROLL_PROGRAM',
    title: t('programs.adminProgramme.errorMessages.deviceTypeErrorEnrollProgram.title'),
    description: t('programs.adminProgramme.errorMessages.deviceTypeErrorEnrollProgram.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.deviceTypeErrorEnrollProgram.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.deviceTypeErrorEnrollProgram.cancelLabel')
  },
  {
    key: 'POTENTIAL_HIGH_ALERTS_VOLUME',
    title: t('programs.adminProgramme.errorMessages.potentialHighAlertsVolume.title'),
    description: t('programs.adminProgramme.errorMessages.potentialHighAlertsVolume.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.potentialHighAlertsVolume.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.potentialHighAlertsVolume.cancelLabel')
  },
  {
    key: 'DUPLICATE_VITALS',
    title: t('programs.adminProgramme.errorMessages.duplicateVitals.title'),
    description: t('programs.adminProgramme.errorMessages.duplicateVitals.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.duplicateVitals.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.duplicateVitals.cancelLabel')
  },
  {
    key: 'DUPLICATE_PROGRAMME_NAME',
    title: t('programs.adminProgramme.errorMessages.duplicateProgrammeName.title'),
    description: t('programs.adminProgramme.errorMessages.duplicateProgrammeName.description'),
    submitLabel: t('programs.adminProgramme.errorMessages.duplicateProgrammeName.submitLabel'),
    cancelLabel: t('programs.adminProgramme.errorMessages.duplicateProgrammeName.cancelLabel')
  }
];

// For backward compatibility - components should migrate to use getErrorMessages(t)
const ERROR_MESSAGES = [
  {
    key: 'NO_SELECTED_DEVICES',
    title: 'Device Selection Required',
    description: 'You must select a medical device first to enable the continuous monitoring option.',
    submitLabel: 'Ok',
    cancelLabel: ''
  },
  {
    key: 'DEVICE_TYPE_ERROR_ADMIN_PROGRAM',
    title: 'Device Type Error!',
    description: 'No matching Charge Code is available for the selected device type/model and duration of this Programme. Please create Charge Code first.',
    submitLabel: 'Go to Charge Code',
    cancelLabel: 'Ok'
  },
  {
    key: 'DEVICE_TYPE_ERROR_ENROLL_PROGRAM',
    title: 'Device Type Error!',
    description: 'No matching Charge Code is available for the selected device type/model and duration of this Programme. Please reach out to your Administrator for assistance.',
    submitLabel: 'Ok',
    cancelLabel: ''
  },
  {
    key: 'POTENTIAL_HIGH_ALERTS_VOLUME',
    title: 'Potential High Alerts Volume',
    description: 'Since your alert frequency is set to less than the recommended 5 minutes, you may receive a high number of notifications for this vital sign. \\n\\nWould you like to proceed?',
    submitLabel: 'Yes, proceed',
    cancelLabel: 'No, return'
  },
  {
    key: 'DUPLICATE_VITALS',
    title: 'Continuous Monitoring Vitals with other device not supported',
    description: 'If you select a continuous monitoring programme, you cannot another set of device in the same programme.',
    submitLabel: 'Ok',
    cancelLabel: ''
  },
  {
    key: 'DUPLICATE_PROGRAMME_NAME',
    title: 'Duplicate Programme Template',
    description: 'There is another Programme Template with the same name, would you like to proceed?',
    submitLabel: 'Yes, proceed',
    cancelLabel: 'No, return'
  }
];

export { CONTRACT_FREQUENCY, SUSPENSION_REASON, EXTENSION_REASON, CRUD_SEND_TO_PARTICIPANT_VIA, ERROR_MESSAGES, getContractFrequency, getSuspensionReason, getExtensionReason, getCrudSendToParticipantVia, getErrorMessages };

